import './Proyect.css';
import videoisef from '../Assets/Video/videoisef.mp4';
import videopetit from '../Assets/Video/videopetit.mp4';
import { Fade } from "react-awesome-reveal";

function Proyect() {
  return (
    <div className='proyectos-super'>
      <h1>PROYECTOS TRESATEC</h1>
      
      <div className='proyectos-grid'>
        {/* Proyecto ISEF */}
        <div className='proyecto-card'>
          <Fade direction='up' triggerOnce cascade damping={0.2}>
            <div className='proyecto-contenido'>
              <h3>ISEF</h3>
              <p>
                Desarrollamos la plataforma digital educativa para el Instituto Superior de Educación Física (ISEF). 
                Esta herramienta modularizada mejora la experiencia de estudiantes y profesores, facilitando el acceso 
                a recursos académicos y la gestión de actividades.
              </p>
              <div className='proyecto-boton'>
                <a href='https://isefcampusvirtual.com.ar/' target='_blank' rel='noopener noreferrer'>
                  <i className='bx bx-right-arrow-alt'></i> Visitar
                </a>
              </div>
            </div>
          </Fade>

          <Fade direction='up' triggerOnce delay={200}>
            <div className='proyecto-video'>
              <video autoPlay muted loop playsInline>
                <source src={videoisef} type="video/mp4" />
              </video>
            </div>
          </Fade>
        </div>

        {/* Proyecto Petit de Meurville (con reverse) */}
        <div className='proyecto-card reverse'>
          <Fade direction='up' triggerOnce cascade damping={0.2}>
            <div className='proyecto-contenido'>
              <h3>Petit de Meurville</h3>
              <p>
                El Instituto Petit de Meurville, primer proyecto educativo asociado al Bachillerato Bilingüe Internacional 
                de la Universidad de Cambridge, ha confiado en nosotros para desarrollar su plataforma educativa, diseñada 
                para facilitar el aprendizaje. Permite una gestión eficiente de los contenidos y actividades, una herramienta 
                que potencia la enseñanza.
              </p>
              <div className='proyecto-boton'>
                <a href='https://institutopetitdemeurville.com.ar/' target='_blank' rel='noopener noreferrer'>
                  <i className='bx bx-right-arrow-alt'></i> Visitar
                </a>
              </div>
            </div>
          </Fade>

          <Fade direction='up' triggerOnce delay={200}>
            <div className='proyecto-video'>
              <video autoPlay muted loop playsInline>
                <source src={videopetit} type="video/mp4" />
              </video>
            </div>
          </Fade>
        </div>
      </div>
    </div>
  );
}

export default Proyect;